import { AuthenticationService } from "../services/authentication.service";
import { ActivatedRoute, Router } from "@angular/router";
import * as _ from 'lodash';
var ValidateOtpComponent = (function () {
    function ValidateOtpComponent(authService, activatedRoute, router) {
        this.authService = authService;
        this.activatedRoute = activatedRoute;
        this.router = router;
        this.msg = 'Validating OTP';
        this.otp = null;
        this.isLoading = true;
        this.showRequestOTP = false;
    }
    ValidateOtpComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.activatedRoute.queryParams.subscribe(function (params) {
            _this.otp = params['password'];
            console.log(params);
            if (_.isNull(_this.otp) || _.isEmpty(_this.otp)) {
                console.log(_this.otp);
                _this.isLoading = false;
                _this.msg = 'OTP is empty, failed.';
                return;
            }
            _this.validateOTP(_this.otp);
        });
    };
    ValidateOtpComponent.prototype.validateOTP = function (otp) {
        var _this = this;
        this.authService.validateOTP(otp).subscribe(function (success) {
            var token = _.get(success, 'token');
            localStorage.clear();
            localStorage.setItem('currentUser', token);
            _this.authService.updateUserInfo(success);
            if (token != null) {
                _this.router.navigate(['']);
            }
        }, function (failed) {
            _this.isLoading = false;
            _this.showRequestOTP = true;
            _this.msg = failed.error['detail'];
        });
    };
    return ValidateOtpComponent;
}());
export { ValidateOtpComponent };



// WEBPACK FOOTER //
// /opt/app/src/app/validate-otp/validate-otp.component.ts.pre-build-optimizer.js